var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-nowrap"},[_vm._v(_vm._s(_vm.priceFormated)+" "),_c('span',{class:{'text-muted':_vm.formated},domProps:{"innerHTML":_vm._s(_vm.$options.filters.currencySign(_vm.price.currency.name))}})])}
var staticRenderFns = []

export { render, staticRenderFns }